var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { returnError, TextArea, TextField, CheckboxField } from "@atlassiansox/microscopekit";
var CreateKeyForm = /** @class */ (function (_super) {
    __extends(CreateKeyForm, _super);
    function CreateKeyForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onCheck = function () { return __awaiter(_this, void 0, void 0, function () {
            var keypair, _a, message, graphQLErrors, errMsg;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setState({ generateKeyChecked: !this.state.generateKeyChecked });
                        if (!!this.state.generateKeyChecked) return [3 /*break*/, 6];
                        if (!this.state.keyId) return [3 /*break*/, 5];
                        this.setState({ keyIdInvalid: false });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.generateKeypair({
                                variables: {
                                    keyId: this.state.keyId
                                }
                            })];
                    case 2:
                        keypair = _b.sent();
                        if (keypair && keypair.data) {
                            this.setState({
                                publicKeyPem: keypair.data.generateKeypair.publicKeyPem,
                                privateKeyPem: keypair.data.generateKeypair.privateKeyPem,
                                privateKeyData: keypair.data.generateKeypair.privateKeyDataUri
                            });
                        }
                        else {
                            this.props.showFlag({
                                type: "error",
                                title: "Error",
                                message: "Failed to generate new keypair"
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        message = _a.message, graphQLErrors = _a.graphQLErrors;
                        errMsg = returnError(graphQLErrors, message)[0];
                        this.props.showFlag({
                            type: "error",
                            title: "Error",
                            message: errMsg
                        });
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.setState({ keyIdInvalid: true, generateKeyChecked: false });
                        _b.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            keyId: "micros/" + props.serviceId + "/" + Math.floor(Date.now() / 1000),
            keyIdInvalid: false,
            privateKeyData: undefined,
            privateKeyPem: undefined,
            publicKeyPem: undefined,
            generateKeyChecked: false
        };
        return _this;
    }
    CreateKeyForm.prototype.render = function () {
        var _this = this;
        var onChange = this.props.onChange;
        var generatedPrivateKeyFields = (React.createElement(React.Fragment, null,
            React.createElement(TextArea, { name: "privateKeyPem", label: "Private Key Pem", value: this.state.privateKeyPem, isReadOnly: true, isMonospaced: true, minimumRows: 12 }),
            React.createElement(TextArea, { name: "privateKeyData", label: "Private Key Data URI", value: this.state.privateKeyData, isReadOnly: true, isMonospaced: true, minimumRows: 12 })));
        return (React.createElement(React.Fragment, null,
            React.createElement(TextField, { name: "keyId", label: "Key ID", isRequired: true, value: this.state.keyId, isInvalid: this.state.keyIdInvalid, onChange: function (e) {
                    _this.setState({ keyId: e.target.value, keyIdInvalid: false });
                    onChange(_this.state);
                } }),
            React.createElement(CheckboxField, { name: "generateKeypair", label: "Generate a new key pair", isChecked: this.state.generateKeyChecked, onChange: function () {
                    _this.onCheck().then(function () { return onChange(_this.state); });
                } }),
            React.createElement(TextArea, { name: "publicKey", label: "Public Key", value: this.state.publicKeyPem, onChange: function (e) {
                    _this.setState({ publicKeyPem: e.target.value });
                    onChange(_this.state);
                }, isRequired: true, isMonospaced: true, placeholder: "-----BEGIN PUBLIC KEY-----\n" +
                    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsu5zw6Cf0Gh65nVl9iYY\n" +
                    "SKhuulRb+nJBNA2aGZoVSnBq/tjEL/6yw1XfkxMOi4iT6HaEvB001SJLnrGi8dyc\n" +
                    "PMH0PEk4Jn7rShc+zPTI1sOvU69wOJtljZS24+xglk9ZQKPYwVn+qG6AWvsJ3l3N\n" +
                    "OvqZw3ZGSIXhMHzewyusDf9Lyl3bvPqFjCj2GiYSyODnD1xty2b6ToNblhpArUXt\n" +
                    "vfuaAI/cJ88iUbjn8aFRBZA3WNuBvJESs9h3J01y5dy4o0sXX2JEl8+WvDhWeezv\n" +
                    "598AOiTEfrc2TRtEStVTbjNp6O4JnJIgTLQFqJOI0d+Uhb/49ibSw+3UDsJTASi6\n" +
                    "QwIDAQAB\n" +
                    "-----END PUBLIC KEY-----\n" }),
            this.state.generateKeyChecked && generatedPrivateKeyFields));
    };
    return CreateKeyForm;
}(React.Component));
export { CreateKeyForm };
